// @spec GHG-FIX-020
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { Skeleton } from '@/components/ui/skeleton';
import { useGHGOrganizationId } from '@/features/ghg/api/use-ghg-organization-id';
import { DataQualityAlertRulesPanel } from '@/features/ghg/components/DataQualityAlertRulesPanel';
import { DataQualityRecommendations } from '@/features/ghg/components/DataQualityRecommendations';
import { DataQualityScoreCard } from '@/features/ghg/components/DataQualityScoreCard';
import { DataQualityTrendChart } from '@/features/ghg/components/DataQualityTrendChart';
import { useGHGPagePeriod } from '@/features/ghg/hooks/use-ghg-page-period';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/ghg/data-quality')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.dataQuality'),
  }),
  component: DataQualityPage,
});

function DataQualityPage() {
  const { t } = useTranslation('ghg');
  const organizationId = useGHGOrganizationId() ?? '';
  const { periodId } = useGHGPagePeriod();

  if (!organizationId) {
    return (
      <div className="p-8">
        <div className="mx-auto max-w-7xl space-y-6">
          <Skeleton className="h-9 w-48" />
          <Skeleton className="h-5 w-80" />
          <Skeleton className="h-96 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-3xl font-semibold text-foreground">{t('dataQualityPage.heading')}</h1>
            <p className="mt-1 text-muted-foreground">
              {t('dataQualityPage.description')}
            </p>
          </div>
        </header>

        <div className="space-y-6">
          <DataQualityScoreCard reportingPeriodId={periodId} showTrend />
          <DataQualityTrendChart />
          <DataQualityRecommendations reportingPeriodId={periodId} />
          <DataQualityAlertRulesPanel
            organizationId={organizationId}
            reportingPeriodId={periodId}
          />
        </div>
      </div>
    </div>
  );
}
